// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
import { SparseItem } from '@/sparse/api/types';

// Returns true when the FE should render serial fields for a shipment line.
// Tracked devices always carry serials; bulk items do iff the per-item flag
// is on. Services (non-physical) never carry serials.
export function shipmentLineAllowsSerials(
  item: SparseItem | null | undefined
): boolean {
  if (!item) {
    return false;
  }
  return item.isPhysical && item.shouldRenderSerialFields;
}
